import styled from '@emotion/styled';
import { Button, Popover } from 'antd';

import { useOrgValue } from 'hooks/business/system/useOrg';
import { useFlagConfigValue } from 'hooks/business/system/useFlagConfig';

import { ReactComponent as KefuIcon } from '../assets/erqi/wenhao.svg';
import { ReactComponent as QuickKefuIcon } from '../assets/erqi/wenhao_quick.svg';
import bgLeft from '../assets/erqi/left.png';
import bgRight from '../assets/erqi/right.png';
import { isQuickChat, isTfsoftware } from 'productLine';
import { ChatServiceQrImgTfsoftware } from 'bizComponents/ChatServiceQrImg';
import { T, useTranslate } from '@tolgee/react';

const CompanyInfo = () => {
  const orgValue = useOrgValue();
  const { payQrcode } = useFlagConfigValue();

  const { t } = useTranslate();

  const {
    enabledAccountNum,
    enabledNonReceptionAccountNum,
    nonReceptionAccountNum = 0,
  } = orgValue || {};

  return (
    <TopBar>
      <OrgName>
        {orgValue?.name}{' '}
        <EnableKefuTip>
          {nonReceptionAccountNum > 0 ? (
            <T
              keyName="account.启用不限额帐号x位限额帐号y位"
              params={{ num: <></>, x: enabledAccountNum, y: enabledNonReceptionAccountNum }}
            />
          ) : (
            <>
              <span>{t('market.当前启用接待帐号')} :</span>
              {enabledAccountNum}
            </>
          )}
        </EnableKefuTip>
      </OrgName>
      {isTfsoftware ? (
        <Popover trigger="click" content={<ChatServiceQrImgTfsoftware />}>
          <ClientBtn
            type="primary"
            shape="round"
            icon={isQuickChat ? <QuickKefuIcon /> : <KefuIcon />}
          >
            {t('market.联系客户服务专家')}
          </ClientBtn>
        </Popover>
      ) : (
        <Popover
          trigger="click"
          content={
            <Help>
              <div>
                {t('market.若在使用/购买过程中遇到问题或其他需求')}
                <br />
                {t('market.可随时扫码联系我们的客户服务专家')}
              </div>
              <img src={payQrcode} alt="qrcode" />
            </Help>
          }
        >
          <ClientBtn
            type="primary"
            shape="round"
            icon={isQuickChat ? <QuickKefuIcon /> : <KefuIcon />}
          >
            {t('market.联系客户服务专家')}
          </ClientBtn>
        </Popover>
      )}
    </TopBar>
  );
};

export default CompanyInfo;

const TopBar = styled.div`
  height: 56px;
  background: ${isQuickChat ? '#EBEAFB' : '#f7faff'};
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-image: url(${bgLeft}), url(${bgRight});
  background-position: left 6px, right 0px;
  background-size: 120px, 120px;
  background-repeat: no-repeat, no-repeat;
  [data-color-mode='dark'] & {
    background-color: var(--fett-bg-panel);
  }
`;
const OrgName = styled.span`
  color: var(--fett-text-primary);
  margin-left: 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const EnableKefuTip = styled.span`
  height: 24px;
  border: 1px solid #fbcece;
  color: var(--fett-surface-error-text);
  font-size: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  margin-left: 12px;
  span {
    margin-right: 4px;
  }
`;
const ClientBtn = styled(Button)`
  display: flex;
  margin-right: 16px;
  span {
    margin-left: 8px;
  }
`;
const Help = styled.div`
  width: 320px;
  padding: 8px;
  text-align: center;
  color: var(--fett-text-primary);
  > * {
    margin-bottom: 16px;
  }
  > h3 {
    font-size: 16px;
    color: var(--fett-text-primary);
  }
  > img {
    width: 160px;
    height: 160px;
    margin: 0 auto;
    display: block;
  }
`;
